import { theme } from '@frontend/theme';
import { AvatarPill } from './avatar-pill';

export interface DatePillProps {
  dayOfMonth: number; // e.g.: 21, 4, 5 etc
  weekday: string; // e.g.: Monday, Tuesday etc
  isSelected?: boolean;
}

const PILL_COLORS = {
  default: {
    avatarText: theme.colors.neutral90,
    avatarFill: theme.colors.neutral20,
    labelBackground: theme.colors.neutral10,
  },
  selected: {
    avatarText: theme.colors.white,
    avatarFill: theme.colors.primary50,
    labelBackground: theme.colors.primary10,
  },
};

export const DatePill = ({ dayOfMonth, weekday, isSelected }: DatePillProps) => {
  const colors = isSelected ? PILL_COLORS.selected : PILL_COLORS.default;
  const firstDigit = Math.floor(dayOfMonth / 10);
  const secondDigit = dayOfMonth % 10;
  return (
    <AvatarPill
      labelText={weekday}
      css={{ '> p': { backgroundColor: colors.labelBackground } }}
      avatarProps={{
        firstName: firstDigit.toString(),
        lastName: secondDigit.toString(),
        bypassColor: { text: colors.avatarText, fill: colors.avatarFill },
        disableHoverLabel: true,
      }}
    />
  );
};
